import { render, staticRenderFns } from "./OTreeSelect.vue?vue&type=template&id=2b5baddb&"
import script from "./OTreeSelect.vue?vue&type=script&lang=js&"
export * from "./OTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports